import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Input, Upload, notification, AutoComplete } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { importData } from '../manageques.action';
import { fetchquestionnaireNames } from 'containers/QuestionCategory/category.action';

const { Dragger } = Upload;

export const ImportModal = ({
  isModalOpen,
  handleOk,
  handleCancel,
  loader,
  years,
  currentQues,
  activeYear,
  isEdit
}) => {
  const dispatch = useDispatch();
  const [fileList, setFileList] = useState([]);
  const [form] = Form.useForm();

  useEffect(() => {
    // Only set fields if currentQues is not empty
    if (currentQues && Object.keys(currentQues).length > 0) {
      form.setFieldsValue({
        id: currentQues.id || '',
        title: currentQues.name || '',
        year: currentQues.year || activeYear || '',
        file: []
      });
    } else {
      form.resetFields();
    }

    // Cleanup function to reset form fields when the modal is closed or form is unmounted
    return () => {
      form.resetFields();
    };
  }, [currentQues, activeYear, form]);

  useEffect(() => {
    if (!loader) {
      dispatch(fetchquestionnaireNames(activeYear));
      if (currentQues && !(Object.keys(currentQues).length > 0)) {
        form.resetFields();
      }
    }

    // eslint-disable-next-line
  }, [loader]);

  const onFinish = async (values) => {
    const { title, year } = values;
    const formData = new FormData();

    // Make sure a file has been uploaded before proceeding
    if (fileList.length > 0) {
      formData.append('file', fileList[0].originFileObj);
    }

    const payload = {
      file: formData,
      title: isEdit ? '' : title,
      year:  year,
      id: values.id || ''
    };
    // console.log('payload', payload);

    dispatch(importData(payload));
  };

  const beforeUpload = (file) => {
    const isCSVOrXLSX =
      file.type === 'application/vnd.ms-excel' ||
      file.name.endsWith('.csv') ||
      file.name.endsWith('.xlsx');

    if (!isCSVOrXLSX) {
      notification.error({
        message: 'Invalid File Type',
        description: 'You can only upload CSV or XLSX files.',
        duration: 5
      });
      return false;
    }
    return false;
  };

  const handleChange = ({ fileList: newFileList }) => setFileList(newFileList);

  const yearOptions = years.map((year) => ({ value: year }));

  return (
    <Modal
      title=""
      open={isModalOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      centered
      width={550}
      footer=""
    >
      <h2>Upload Questionnaire</h2>
      <Form layout="vertical" onFinish={onFinish} form={form}>
        <Form.Item label="Hidden Field" name="id" style={{ display: 'none' }}>
          <Input placeholder="This field is hidden" />
        </Form.Item>
        <Form.Item
          label="Title"
          style={{ display: isEdit ? 'none' : '' }}
          name="title"
          rules={[{ required: true, message: 'Please input the title!' }]}
        >
          <Input placeholder="Enter title" />
        </Form.Item>

        <Form.Item
          label="Year"
          name="year"
          // style={{ display: isEdit ? 'none' : '' }}
          rules={[{ required: true, message: 'Please input the year!' }]}
        >
          <AutoComplete
            placeholder="Enter year"
            options={yearOptions}
            onChange={(value) => {
              if (/[^0-9]/.test(value)) {
                form.setFieldsValue({
                  year: value.replace(/[^0-9]/g, '')
                });
              }
            }}
          />
        </Form.Item>

        <Form.Item
          label="Upload File"
          name="file"
          rules={[{ required: true, message: 'Please upload a file!' }]}
        >
          <Dragger
            name="file"
            multiple={false}
            maxCount={1}
            beforeUpload={beforeUpload}
            onChange={handleChange}
          >
            <p className="ant-upload-drag-icon">
              <UploadOutlined />
            </p>
            <p className="ant-upload-text">Click or drag file to this area to upload</p>
            <p className="ant-upload-hint">Only upload CSV or XLSX files</p>
          </Dragger>
        </Form.Item>

        <Form.Item shouldUpdate>
          <Button type="primary" htmlType="submit"  block disabled={loader}
    loading={loader}>  
            Upload
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ImportModal;
//loading={loader}